import styled from 'styled-components';

export const Title = styled.div`
	font-size: 20px;
	margin: 10px 0 30px;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
  margin-bottom: -30px;
`;
